var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.335937,
    y: 0.335937,
    width: 22.1719,
    height: 15.4531,
    rx: 2.35156,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.671874
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2228 10.6549H5.83891L4.80116 6.57943C4.75191 6.39195 4.64732 6.22622 4.49348 6.1481C4.10956 5.9518 3.6865 5.79557 3.22498 5.71678V5.55987H5.45431C5.76199 5.55987 5.99275 5.79557 6.03121 6.06931L6.56965 9.00911L7.95286 5.55987H9.29829L7.2228 10.6549ZM10.0675 10.6549H8.76056L9.83677 5.55987H11.1437L10.0675 10.6549ZM12.8346 6.97138C12.873 6.69696 13.1038 6.54005 13.373 6.54005C13.7961 6.50066 14.2569 6.57945 14.6415 6.77507L14.8723 5.67808C14.4877 5.52118 14.0646 5.44238 13.6807 5.44238C12.4122 5.44238 11.4891 6.14812 11.4891 7.1276C11.4891 7.87274 12.143 8.26399 12.6045 8.49969C13.1038 8.73471 13.2961 8.89162 13.2576 9.12664C13.2576 9.47917 12.873 9.63608 12.4891 9.63608C12.0276 9.63608 11.566 9.51857 11.1437 9.32226L10.9129 10.4199C11.3744 10.6156 11.8737 10.6944 12.3352 10.6944C13.7576 10.7331 14.6415 10.028 14.6415 8.96973C14.6415 7.63704 12.8346 7.55893 12.8346 6.97138ZM19.2156 10.6549L18.1778 5.55987H17.0631C16.8324 5.55987 16.6016 5.71678 16.5247 5.9518L14.603 10.6549H15.9485L16.217 9.91047H17.8701L18.024 10.6549H19.2156ZM17.2555 6.932L17.6394 8.85224H16.5632L17.2555 6.932Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.985236a542d2acaf1b7d003e1f2a0271.svg";
export { ForwardRef as ReactComponent };